import { useSelector } from 'react-redux';
import { Grid,makeStyles,MenuItem } from '@material-ui/core';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import {
    AddCircle as AddCircleIcon,
  } from '@material-ui/icons';
import { useTranslation } from 'react-i18next';
import uuid from 'react-uuid';
import QCXFinalTextField from '../../shared-components/final-text-field/QCXFinalTextField';
import QCXFinalAlternativeCurrencyField from '../../shared-components/final-currency-field/QCXFinalAlternativeCurrencyField';
import QCXFormStepWizard from '../../shared-components/form-step-wizard/QCXFormStepWizard';
import QCXFinalBondManagerOld from '../../shared-components/final-gerenciador-relacionamento/QCXFinalBondManagerOld';
import { selectDespesasReceitas } from '../../features/despesa-receita/despesaReceitaSlice';
import { selectMoedas } from '../../features/moeda/moedaSlice';
import { unnormalizeNumeral } from '../../utils/general/general-utils';
import QCXSelectUnidadeMedidaAutocomplete from '../../shared-components/select-unidade-medida/QCXSelectUnidadeMedidaAutocomplete';
import { houseVolumesSelectors, houseVolumesSliceActions } from '../../features/house-volume/houseVolumeSlices';


const useStyles = makeStyles(() => ({
    dataGridDiv: {
      width: 'calc(100% - 0px) !important',
    },
  }));

export default function QCXHouseVolumesForm({
    initialValues, 
    handleSubmit,
    isConsult,
    isUpdate,
    controlComponentProps,
    authInfo = {},
    Roles = [],
    dataGridDivProps = {},
    rowsItens = [],
}) {

    const { t } = useTranslation();

    const despesas = useSelector(selectDespesasReceitas);

    const moedas = useSelector(selectMoedas);

    const [tipoPagamento, setTipoPagamento] = useState(null);

    const handleTipoPagamentoChange = (event) => {
        setTipoPagamento(event.target.value);
    };

    const [declarado, setDeclarado] = useState(null);

    const handleDeclaradoChange = (event) => {
        setDeclarado(event.target.value);
    };

    const [profit,setProft] = useState(null);

    const handleProfitChange = (event) => {
        setProft(event.target.value);
    };

    const [calculo,setCalculo] = useState(null);

    const isCalculoHasValueIsEmbarque = () => calculo === "EMBARQUE";

    const handleCalculoChange = (event) => {
        setCalculo(event.target.value);
    };

    const handleAdd = useCallback(async (currentVinculo, currentVinculos, handleSuccessAddVinculo) => {

        const custo = {
            id: uuid(),
            quantidadeVolumes: (currentVinculo?.quantidadeVolumes),
            pesoBruto: (currentVinculo?.pesoBruto),
            unidadeDeMedida: (currentVinculo?.unidadeDeMedida),
            comprimento: currentVinculo?.comprimento,
            altura: currentVinculo?.altura,
            largura: currentVinculo?.largura,
            chargeableWeight: currentVinculo?.chargeableWeight,
            descricaoMercadoria: currentVinculo?.descricaoMercadoria,
            numeroContainer: currentVinculo?.numeroContainer,
            numeroLacre: currentVinculo?.numeroLacre,
            // tipoContaine: null, // descomenta se precisar
            pesoCubado: currentVinculo?.pesoCubado,
          }

        const updatedVinculos = [...currentVinculos, custo];

        handleSuccessAddVinculo(updatedVinculos);

    },[declarado,profit]);

    const handleUpdate = useCallback( async () => {

    });

    const handleReferencia = () => false;

    const config =useMemo(() => ({
            selectors: {
                selectStatus: houseVolumesSelectors.selectStatus,
                selectMode: houseVolumesSelectors.selectMode,
                selectModel: houseVolumesSelectors.selectModel,
            },
            actions: {
                loading: houseVolumesSliceActions.loading,
                resetStatus: houseVolumesSliceActions.resetStatus,
                changeToUpdateMode: houseVolumesSliceActions.changeToUpdateMode,
                changeToCreateMode: houseVolumesSliceActions.changeToCreateMode,
                resetMode: houseVolumesSliceActions.resetMode,
                setModel: houseVolumesSliceActions.setModel,
                resetModel: houseVolumesSliceActions.resetModel,
            },
    }),[]);

    const listProps =  useMemo(
        () => ({
        name: 'volumes',
        columns: [
            {
                field: 'quantidadeVolumes',
                headerName: "Qtde. Volumes",
                headerAlign: 'left',
                align: 'left',
                flex: 140,
                valueGetter: ({ row }) => unnormalizeNumeral(row?.quantidadeVolumes) || '-',
            },
            {
                field: 'pesoBruto',
                headerName: "Peso Bruto",
                headerAlign: 'left',
                align: 'left',
                flex: 140,
                valueGetter: ({ row }) => unnormalizeNumeral(row?.pesoBruto) || '-',
            },
            {
                field: 'unidadeDeMedida',
                headerName: " Un. Medida",
                headerAlign: 'left',
                align: 'left',
                flex: 140,
                valueGetter: ({ row }) => row?.unidadeDeMedida?.description || '-',
            },
            {
                field: 'comprimento',
                headerName: "Comprimento",
                headerAlign: 'left',
                align: 'left',
                flex: 140,
                valueGetter: ({ row }) => unnormalizeNumeral(row?.comprimento) || '-',
            },
            {
                field: 'altura',
                headerName: "Altura",
                headerAlign: 'left',
                align: 'left',
                flex: 140,
                valueGetter: ({ row }) => unnormalizeNumeral(row?.altura) || '-',
            },
            {
                field: 'largura',
                headerName: "Largura",
                headerAlign: 'left',
                align: 'left',
                flex: 140,
                valueGetter: ({ row }) => unnormalizeNumeral(row?.largura) || '-',
            },
            {
                field: 'chargeableWeight',
                headerName: "Chargeable",
                headerAlign: 'left',
                align: 'left',
                flex: 140,
                valueGetter: ({ row }) => unnormalizeNumeral(row?.chargeableWeight) || '-',
            },
        ],
        }),
        []
    );

    const formProps = useMemo(
        () => ({
            rootName: 'ignorableFields.volumes',
            fields: [      
                {
                    name: 'quantidadeVolumes',
                    label: "Quantidade de volumes",
                },
                {
                    name: 'pesoBruto',
                    label: "Peso Bruto",
                },
                {
                    name: 'comprimento',
                    label: "Comprimento",
                },
                {
                    name: 'altura',
                    label: "Altura",
                },
                {
                    name: 'largura',
                    label: "Largura",
                },
                {
                    name: 'chargeableWeight',
                    label: "Chargeable Weight",
                },
                {
                    name: 'descricaoMercadoria',
                    label: "Descrição de mercadoria",
                },
            ],
        }),
        []
    );

    return (
        <QCXFormStepWizard
            initialValues={initialValues}
            onSubmit={handleSubmit}
            controlComponentProps={controlComponentProps}
            onChangeListeners={undefined}
            authInfo={authInfo}
            Roles={Roles}
        >
            {({values}) => (
                <>
                    <Grid container spacing={2} style={ { 'marginTop': '20px' }} xs={12} sm={12} md={12} lg={12} >
                        <Grid item xs={12} sm={3} md={3} lg={3} >
                            <QCXFinalTextField
                            id="numero-processo-mercadoria-code"
                            key="numero-processo-mercadoria-code"
                            name="numeroProcesso"
                            label={t('com.muralis.qcx.agenciamento.numero_processo')}
                            disabled
                            />
                        </Grid>
                    </Grid>
                    <QCXFinalBondManagerOld
                        isParentConsult={isConsult}
                        reducerConfig={config}
                        listProps={listProps}
                        formProps={formProps}
                        controlButtonsGridProps={{
                            add: {
                            xs: 12,
                            sm: 4,
                            md: 4,
                            },
                            update: {
                            xs: 6,
                            sm: 2,
                            md: 2,
                            },
                            clear: {
                            xs: 6,
                            sm: 2,
                            md: 2,
                            },
                        }}
                        handleAdd={handleAdd}
                        handleUpdate={handleUpdate}
                        handleAlreadyExists={handleReferencia}
                    >
                        {({ loading }) => ( 
                            <>
                                <Grid container spacing={2} style={ { 'marginTop': '20px' }} xs={12} sm={12} md={12} lg={12}>
                                    <Grid item xs={12} sm={3} md={3}>
                                        <QCXFinalAlternativeCurrencyField
                                            id="text-field-quantidade-volumes"
                                            key="text-field-quantidade-volumes"
                                            name="ignorableFields.volumes.quantidadeVolumes"
                                            label="Quantidade de volumes"
                                            disabled={isConsult || loading}
                                            />
                                    </Grid>
                                    <Grid item xs={12} sm={3} md={3}>
                                        <QCXFinalAlternativeCurrencyField
                                            id="text-field-peso-bruto"
                                            key="text-field-peso-bruto"
                                            name="ignorableFields.volumes.pesoBruto"
                                            label="Peso Bruto"
                                            disabled={isConsult || loading}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={3} md={3} lg={3}>
                                        <QCXSelectUnidadeMedidaAutocomplete
                                            id="text-field-unidade-de-medida"
                                            key="text-field-unidade-de-medida"
                                            name="ignorableFields.volumes.unidadeDeMedida.id"
                                            label="Unidade de Medida"
                                            disabled={isConsult || loading}
                                        />
                                    </Grid>
                                </Grid>
                                                
                                <Grid container spacing={2} style={ { 'marginTop': '20px' }} xs={12} sm={12} md={12}>
                                    <Grid item xs={12} sm={3} md={3}>
                                        <QCXFinalAlternativeCurrencyField
                                            id="text-field-comprimento"
                                            key="text-field-comprimento"
                                            name="ignorableFields.volumes.comprimento"
                                            label="Comprimento"
                                            disabled={isConsult || loading}
                                            />
                                    </Grid>
                                    <Grid item xs={12} sm={3} md={3}>
                                        <QCXFinalAlternativeCurrencyField
                                            id="text-field-altura"
                                            key="text-field-altura"
                                            name="ignorableFields.volumes.altura"
                                            label="Altura"
                                            disabled={isConsult || loading}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={3} md={3}>
                                        <QCXFinalAlternativeCurrencyField
                                            id="text-field-largura"
                                            key="text-field-largura"
                                            name="ignorableFields.volumes.largura"
                                            label="Largura"
                                            disabled={isConsult || loading}
                                        />
                                    </Grid>
                                </Grid>
                            
                                <Grid container spacing={2} style={ { 'marginTop': '20px' }}  xs={12} sm={12} md={12}>
                                    <Grid item xs={12} sm={3} md={3}>
                                        <QCXFinalAlternativeCurrencyField
                                            id="text-field-chargeable-weight"
                                            key="text-field-chargeable-weight"
                                            name="ignorableFields.volumes.chargeableWeight"
                                            label="Chargeable Weight"
                                            disabled={isConsult || loading}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={9} md={9} lg={9} >
                                        <QCXFinalTextField
                                            id="text-field-descricao-mercadoria"
                                            key="text-field-descricao-mercadoria"
                                            name="ignorableFields.volumes.descricaoMercadoria"
                                            label="Descrição de mercadoria"
                                            disabled={isConsult || loading}
                                        />
                                    </Grid>
                                </Grid>
                            </>
                        )}
                    </QCXFinalBondManagerOld>
                </>
            )}
        </QCXFormStepWizard>
    );
}